// extracted by mini-css-extract-plugin
var _1 = "TopicCardContent-module__basic--ImZyr";
var _2 = "TopicCardContent-module__description--RNSsx";
var _3 = "TopicCardContent-module__header--pIXce";
var _4 = "TopicCardContent-module__subTopics--B1HhX";
export { _1 as "basic", _2 as "description", _3 as "header", _4 as "subTopics" }
